module.exports = __webpack_public_path__ + "img/pt.abc9ef40.svg";